import { useTopicCardContext } from '../contexts/TopicCardContext';
import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';

const useTopicDescription = () => {
  const { isConnectedUser } = useTopicsIndexContext();
  const { canRemoveDescriptionPlaceholder, topic } = useTopicCardContext();
  const {
    description,
    description_visible_in_frontoffice: descriptionVisibleInFrontOffice,
    name,
  } = topic;

  return {
    canRemoveDescriptionPlaceholder,
    description,
    descriptionVisibleInFrontOffice,
    isConnectedUser,
    name,
  };
};

export default useTopicDescription;
